<template>
  <div class="home">
    <Head :logo="logo"></Head>
    <van-tabs v-model="active" color='#1989fa' swipeable animated>
          <van-tab title="录入缴费信息">
                <van-form>
                    <div v-for="(item,index) in formConfig" :key="index"> 
                        <!-- input 输入框 -->
                        <van-field  v-if='item.type=="input"' 
                        @blur="fixed2(queryInfo,item)" 
                        v-model="queryInfo[item.label]" 
                        :label="item.showName" label-class='formTitle'  :placeholder="item.notice" />
                        <!-- 选择单位 -->
                        <van-field v-if='item.label=="deptId"' readonly clickable :label="item.showName" :value="deptName" label-class='formTitle' :placeholder="item.notice" @click="clickSelct(item)"/>
                        <!-- 选择项目 -->
                        <van-field v-if='item.label=="itemId"' readonly clickable :label="item.showName" :value="itemName" label-class='formTitle' :placeholder="item.notice" @click="clickSelct(item)"/>
                        <!-- 开关 -->
                        <van-cell v-if='item.type=="switch"' center :title="item.showName" class='formSwitch'>
                            <template>
                                <van-switch v-model="queryInfo[item.label]" size="24" />
                            </template>
                        </van-cell>
                        <!-- 输入框，选择性显示 -->
                        <van-field  v-if='item.type=="isInput" && queryInfo.isAgent==true' v-model="queryInfo[item.label]" :label="item.showName" label-class='formTitle'  :placeholder="item.notice" />
                    </div>
                </van-form>
          </van-tab>
        <van-tab title="查询已缴费">
            <van-form>
                <div v-for="(item,index) in formPay" :key="index"> 
                    <!-- input 输入框 -->
                    <van-field  v-if='item.type=="input"' v-model="queryInfoPay[item.label]" :label="item.showName" label-class='formTitle'  :placeholder="item.notice" />
                </div>
            </van-form>
        </van-tab>
    </van-tabs>
     <PrivacyDialog person='1' @getReadState='getReadState' ></PrivacyDialog>
    <!-- 单位 -->
      <van-popup v-model="showDept" round position="bottom">
        <van-picker show-toolbar title="选择单位" :columns="deptList"  @cancel="showDept = false" @confirm="onConfirmDept"/>
      </van-popup>
    <!-- 收费项目 -->
    <van-popup v-model="showItem" round position="bottom">
        <van-picker show-toolbar title="选择收费项目" :columns="itemList" @cancel="showItem = false" @confirm="onConfirmItem"/>
    </van-popup>
    <van-button v-if='active==0' round block type="info" native-type="submit" :disabled='showPay?false:true'  class="btn" @click="toPay">支 付</van-button>
    <van-button v-if='active==1' round block type="info" native-type="submit"  class="btn" @click="nextStep">下一步</van-button>
    <Foot v-if="list && list.bottomMessage && list.bottomMessage.length>0" :list="list"></Foot>

    <van-dialog v-model="showDialog" title="提示" >
    </van-dialog>
     <div id="widget" />
  </div>
</template>

<script>
import Head from "@/components/head";
import Foot from "@/components/foot";
import { Dialog } from "vant";
import {judgeVde} from "@/utils/publicJudge";
import { Picker,Toast } from 'vant';
import PrivacyDialog from '@/components/dialog/privacyDialog'
import {savePrivacy} from '@/utils/common.js'

let loadedMineMapJs = false;
export default {
  name: "Home",
  components: {
    Head,
    Foot,
    PrivacyDialog
  },
  data() {
    return {
      active:0,
      showDialog:false,
      showItem:false,//收费项目显示
      showDept:false,//单位显示
      logo: "",
      vde: "",
      list: [],
      columns:[],
      formConfig:[{type:'select',showName:'执收单位',label:'deptId',options:[],notice:'请选择执收单位'},
                   {type:'select',showName:'收费项目',label:'itemId',options:[],notice:'请选择收费项目'},
                   {type:'input',showName:'案件号码',label:'caseNumber',notice:'请输入案件号码'},
                   {type:'input',showName:'缴款人(单位)',label:'paymentUnit',notice:'请输入缴款人（单位）'},
                   {type:'input',showName:'身份证号',label:'idCard',notice:'请输入身份证号'},
                   {type:'input',showName:'手机号码',label:'phone',notice:'请输入手机号码'},
                   {type:'switch',showName:'是否代缴',label:'isAgent'},
                   {type:'isInput',showName:'代缴人姓名',label:'agentName',notice:'请输入代缴人姓名'},
                   {type:'isInput',showName:'代缴人手机号码',label:'agentPhone',notice:'请输入代缴人手机号码'},
                   {type:'isInput',showName:'代缴人身份证号',label:'agentIdCard',notice:'请输入代缴人身份证号'},
                   {type:'input',showName:'缴费金额',label:'paymentTotal',notice:'请输入缴费金额（元）'},
                ],
      formPay:[{type:'input',showName:'缴款人（单位）',label:'paymentUnit',notice:'请输入缴款人（单位）'},
               {type:'input',showName:'缴款人身份证号',label:'idCard',notice:'请输入缴款人身份证号'},
               {type:'input',showName:'缴款人手机号码',label:'phone',notice:'请输入缴款人手机号码'},
             ],
      queryInfo:{
          deptId:'',
          itemId:'',
          caseNumber:'',
          paymentUnit:'',
          idCard:'',
          phone:'',
          isAgent:false,
          agentName:'',
          agentPhone:'',
          agentIdCard:'',
          paymentTotal:'',
      },
      queryInfoPay:{
          paymentUnit:'',
          idCard:'',
          phone:''
      },
      params:'',
      deptId:'',
      deptList:[],
      itemList:[],
      deptName:'',//单位名称
      itemName:'',//项目名称
      showPay:true,//显示支付按钮
      isRead:false,
      details:[],
    };
  },
  created() {
    if (this.$route.query.vde === undefined) {
      this.vde = "";
    } else {
      this.vde = this.$route.query.vde;
    }
    // 时间加密参数
    if (this.$route.query.params === undefined) {
      this.params = "";
    } else {
      this.params = this.$route.query.params;
    }
    this.getTimePower()
   
  },
  methods: {
    fixed2(val,item){
      if(item.label=="paymentTotal"){
        val.paymentTotal=Number(val.paymentTotal).toFixed(2);
      }
    },
     getReadState(isRead,details) {
      this.isRead = isRead;
      this.details = details;
    },
    // 存储隐私授权接口
    savePrivacy(type) {
      if (type == 'pay') {
          let data = {
            details:this.details,
            userId:this.queryInfo.paymentUnit,
            userName:this.queryInfo.idCard ,
          };
          savePrivacy(data);
      }else if (type == 'search') {
        let data = {
          details:this.details,
          userId:this.queryInfoPay.paymentUnit,
          userName: this.queryInfoPay.idCard?this.queryInfoPay.idCard:
                    this.queryInfoPay.phone?this.queryInfoPay.phone:this.queryInfoPay.paymentUnit,
        }
        savePrivacy(data);
      }
    },
    // 获取链接有效期权限
    getTimePower() {
      let data= {params:this.params}
      this.request({
        url:'/mobile/decodeParams',
        method:'get',
        params:data
      }).then((res)=>{
        if (res.data.code==1000) {
          this.deptId = res.data.result.deptId
          this.deptName = res.data.result.deptName
          this.vde = res.data.result.vde
          this.getDeptList()
          this.getItemList()
          //判断vde
          judgeVde({vde:this.vde},this)
          this.getHeadImg();
          this.getFootData();
        }else {
           Dialog.alert({
            title: "提示",
            message: res.data.message
          }).then(() => {
            this.$router.push({ path: "/404" })
          });
        }
      })
    },
     getHeadImg() {
          let data = {}
          data.vde = this.vde
          this.request({
            url:'/webPortal/websitConfig',
            method:'get',
            params:data
          }).then((res)=>{
            if (res.data.code == 1000 && res.data.result) {
                if (res.data.result.logoUrlLogin) {
                    this.logo = res.data.result.logoUrlLogin
                }else {
                  this.logo = require('@/assets/img/logo.png')
                  }
                sessionStorage.setItem('title',res.data.result.websitTitle)
                document.title=res.data.result.websitTitle 
            }else if (res.data.code != 1000){
                  this.$router.push({ path: "/404" });
            }
          })
      },
    // 获取底部数据
    getFootData() {
      let data = {
        vde: this.vde,
        type: 4
      };
      this.request({
        url:'/systemManage/mobileGetMessage',
        method:'get',
        params:data
      }).then((res)=>{
        if (res.data.code = 1000) {
          this.list = res.data.result;
        }
      })
    },
    // 获取单位
    getDeptList(){
      this.request({
        url:'/selfPay/listSelfOtherDept',
        method:'get',
        params:{vde:this.vde,deptId:this.deptId,configType:'2'}
      }).then((res)=>{
        if (res.data.code == 1000) {
          this.deptList = res.data.result
          this.deptList.forEach((item)=>{
            item.text =  `[${item.deptId}]${item.deptName}`
          })
          this.queryInfo.deptId = this.deptId
          this.showPay = true
        }else{
          this.deptList = []
          this.showPay = false
          Dialog.alert({
              title: "提示",
              message: res.data.message
          }).then(() => {});
        }
      })
    },
    // 获取收费项目
    getItemList(){
      this.request({
        url:'/selfPay/listSelfOtherItem',
        method:'get',
        params:{deptId:this.deptId,configType:'2'}
      }).then((res)=>{
          if (res.data.code == 1000) {
            this.itemList = res.data.result
            this.itemList.forEach((item)=>{
              item.text = item.itemName
            })
            this.showPay = true
          }else{
            this.showPay = false
            this.itemList = []
            Dialog.alert({
                title: "提示",
                message: res.data.message
            }).then(() => {});
          }
      })
    },
    // 点击选择框
    clickSelct(item) {
      if (item.label == 'deptId') {
        if (this.deptList.length>0) {
          this.showDept = true
        }
      }else if (item.label == "itemId") {
        if (this.itemList.length>0) {
          this.showItem = true
        }
      }
    },
    onConfirmDept(val) {
      this.queryInfo.deptId = val.deptId
      this.deptName = val.deptName
      this.showDept = false
    },
    onConfirmItem(val) {
      this.queryInfo.itemId = val.itemId
      this.itemName = val.itemName
      this.showItem = false
    },
    // 支付
    toPay() {
        if(this.isRead == false){
        Dialog.alert({
          title: "提示",
          message: "请先阅读《用户隐私政策》",
        }).then(() => {});
        return;
      }
      if (this.queryInfo.deptId == '') {
         Dialog.alert({
                title: "提示",
                message: "请选择执收单位"
        }).then(() => {});
        return ;
      }
      if (this.queryInfo.itemId == '') {
         Dialog.alert({
                title: "提示",
                message: "请选择收费项目"
        }).then(() => {});
        return ;
      }
      if (this.queryInfo.paymentUnit == '') {
         Dialog.alert({
                title: "提示",
                message: "请输入缴款单位"
        }).then(() => {});
        return ;
      }
      if (this.queryInfo.idCard == '') {
         Dialog.alert({
                title: "提示",
                message: "请输入身份证号"
        }).then(() => {});
        return ;
      }
      let testIdcard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      if(!testIdcard.test(this.queryInfo.idCard)){
        Dialog.alert({
          title: "提示",
          message: "身份证号格式不正确"
        }).then(() => {});
        return false;
      }
      if (this.queryInfo.phone == '') {
         Dialog.alert({
                title: "提示",
                message: "请输入手机号码"
        }).then(() => {});
        return ;
      }
      let testPhone =/^1\d{10}$/
      if(!testPhone.test(this.queryInfo.phone)){
        Dialog.alert({
          title: "提示",
          message: "手机号码格式不正确"
        }).then(() => {});
        return false;
      }

    // 开关开启时验证代缴人
    if(this.queryInfo.isAgent == true) {
      if (this.queryInfo.agentName == '') {
         Dialog.alert({
                title: "提示",
                message: "请输入代缴人姓名"
        }).then(() => {});
        return ;
      }
      if (this.queryInfo.agentPhone == '') {
         Dialog.alert({
                title: "提示",
                message: "请输入代缴人电话号码"
        }).then(() => {});
        return ;
      }
      if (!testPhone.test(this.queryInfo.agentPhone)) {
          Dialog.alert({
                  title: "提示",
                  message: "代缴人手机号码格式不正确"
          }).then(() => {});
          return ;
        }
       if (this.queryInfo.agentIdCard == '') {
         Dialog.alert({
           title: "提示",
                  message: "请输入代缴人身份证号"
          }).then(() => {});
          return ;
       }
      if (!testIdcard.test(this.queryInfo.agentIdCard)) {
          Dialog.alert({
                  title: "提示",
                  message: "代缴人身份证号格式不正确"
          }).then(() => {});
          return ;
        }
    }

      if (this.queryInfo.paymentTotal == '') {
         Dialog.alert({
                title: "提示",
                message: "请输入缴费金额（元）"
        }).then(() => {});
        return ;
      }
     
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
        let data = JSON.parse(JSON.stringify(this.queryInfo))
        data.isAgent = this.queryInfo.isAgent?'1':'0';
        this.savePrivacy('pay')
        this.request({
          baseURL: process.env.VUE_APP_PAY_URL,
          url:'/pay/payInitSelfIpc',
          method:'post',
          data:data
        }).then((res)=>{
            if (res.data.code == 1000) {
              //未加载成功
              if (!loadedMineMapJs) {
                this.asyncLoadJs(res.data.result.thirdpayWidgetJs).then(() => {
                  loadedMineMapJs = true;
                  this.otherPay(res.data.result);
                });
                // 已经加载成功
              } else {
                this.otherPay(res.data.result);
              }
            }else{
              Toast.clear();
                Dialog.alert({
                    title: "提示",
                    message: res.data.message
                }).then(() => {});
                }
        })
    },
    asyncLoadJs(url) {
      var Q = require("q");
      return Q.Promise((resolve, reject) => {
        let srcArr = document.getElementsByTagName("script");
        let hasLoaded = false;
        for (let i = 0; i < srcArr.length; i++) {
          //判断当前js是否加载上
          hasLoaded = srcArr[i].src == url ? true : false;
        }
        if (hasLoaded) {
          resolve();
          return;
        }
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        document.body.appendChild(script);
        script.onload = () => {
          resolve();
        };
        script.onerror = () => {
          reject();
        };
      });
    },
    otherPay(res) {
      let obj = {
        container: "widget", // 挂件在当前页面放置的控件ID
        merchant_no: res.merchant_no, // 分配的商户号
        merchant_order_no: res.merchant_order_no, // 订单在商户系统中的订单号
        amount: res.amount, // 订单价格，单位：人民币 分
        widget_param: res.widget_param,
        subject: res.subject,
        body: res.body,
        charge_url: res.charge_url, // 商户服务端创建Charge字符串的url
        charge_param: res.charge_param,
        device_type: res.device_type, // 设备类型
        effective_time: res.effective_time, // 当天有效，24点失效
        version_no: res.version_no,
      };
      let that = this;
      const interval = setInterval(() => {
        if (loadedMineMapJs) {
          clearInterval(interval);
          // 调起支付
          thirdpay_widget.init(obj);
          Toast.clear();
          that.usepay = true;
        }
      }, 100);
    },
    // 下一步
    nextStep() {
       if(this.isRead == false){
        Dialog.alert({
          title: "提示",
          message: "请先阅读《用户隐私政策》",
        }).then(() => {});
        return;
      }
      let testPhone =/^1\d{10}$/;
      let testIdcard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (this.queryInfoPay.paymentUnit=='' && this.queryInfoPay.idCard=='' && this.queryInfoPay.phone =="") {
            Dialog.alert({
                title: "提示",
                message: "请输入查询条件"
            }).then(() => {});
            return ;
        }else if (this.queryInfoPay.paymentUnit && this.queryInfoPay.idCard=='' && this.queryInfoPay.phone =="") {
            Dialog.alert({
                title: "提示",
                message: "请输入证件号码或者手机号码"
            }).then(() => {});
            return ;
        }else if (this.queryInfoPay.idCard && !testIdcard.test(this.queryInfoPay.idCard)) {
           Dialog.alert({
              title: "提示",
              message: "身份证号格式不正确"
            }).then(() => {});
            return false;
        }else  if(this.queryInfoPay.phone && !testPhone.test(this.queryInfoPay.phone)){
            Dialog.alert({
              title: "提示",
              message: "手机号码格式不正确"
            }).then(() => {});
            return false;
          }else {
            this.savePrivacy('search');
            this.$router.push({
              path:
                "/ipcPay/ipcPayResults?idCard=" +
                this.queryInfoPay.idCard +
                "&paymentUnit=" +
                this.queryInfoPay.paymentUnit +
                "&phone=" +
                this.queryInfoPay.phone +
                "&vde=" +
                this.vde+
                "&deptId=" +
                this.deptId
            });
          }
    },

  }
};

</script>


<style lang="scss">
.home {
  padding: 0 2vw;
  box-sizing: border-box;
  .van-form {
    background: rgba(255, 255, 255, 1);
    box-shadow: 4px 4px 5px 0px rgba(51, 51, 51, 0.05);
    border-radius: 5px;
  }
  .van-cell {
    background: transparent;
  }
  .formTitle {
    padding-right: 20px;
    text-align-last: justify;
    width: 120px;
  }
.formSwitch {
    width: 230px;
    box-sizing: border-box;
    .van-cell__title {
        text-align-last: justify;
        width: 130px;
    }
}
  .btn {
    margin-top: 30px;
  }
}
.van-dialog__header {
    background: #1989fa;
    color: #fff;
    padding: 10px 0 !important;
    font-weight: 600 !important;
}
.notice {
  padding: 15px 10px;
  text-align: center;
  color: #646566;
}
.van-dialog__content {
  text-align: center;
  color: #646566;
  font-size: 15px;
}
</style>